<div class="row event-info-wrapper campaign-image">
  <img class="event-image" [src]="getImageUrl(option)"/>

  <ng-container *ngIf="winner">
    <div class="pyro" style="position: absolute;top: 10rem;left: 12rem;z-index: 2000000;">
      <div class="before"></div>
      <div class="after"></div>
    </div>
  </ng-container>

</div>

<div class="row event-info-wrapper">
  <div class="col-8 current-name-text">
    <div class="option-name"> {{ option.name }} </div>
  </div>
  <div class="col-4 text-right current-option-amount">
    <div class="title-text"> Pledge</div>
    <div class="current-name-text"> {{ option.amount | currency:'USD':'symbol-narrow':'1.0-0' }} </div>
  </div>
</div>

<div *ngIf="winner" class="row event-info-wrapper">
  <div class="widget__separator"></div>
  <div class="d-flex col-12 current-option-leader">
    <app-icon-success></app-icon-success>
    <div class="current-option-leader-name">{{winner.name}}<span> is Winner</span></div>
  </div>
</div>

<div class="widget__separator"></div>

<div class="row event-info-wrapper" *ngIf="isNotEmpty(campaign)">
  <div class="col-8 col-wrapper">
    <div class="title-text">Campaign</div>
    <div class="current-name-text"> {{ campaign.name }} </div>
  </div>

  <div class="col-4 text-right col-wrapper">
    <div class="title-text">Raised</div>
    <div class="current-name-text"> {{ raised | currency:'USD':'symbol-narrow':'1.0-0' }} </div>
  </div>
</div>

<div class="widget__separator"></div>

<div class="row event-info-wrapper" *ngIf="isNotEmpty(event)">
  <div class="title-text">Event</div>
  <div class="current-name-text"> {{ event.name }} </div>
</div>

<div class="widget__separator"></div>
